import { render, staticRenderFns } from "./WarehouseReturns.vue?vue&type=template&id=14a4ded6&"
import script from "./WarehouseReturns.vue?vue&type=script&lang=ts&"
export * from "./WarehouseReturns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports